import clsx from 'clsx';

import { twMerge } from '@polyai/ui/utils/twMerge';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Header = ({ children, className, ...props }: Props) => {
  return (
    <div
      className={twMerge(
        clsx('flex gap-sm1 items-center justify-between mb-sm1', className),
      )}
      {...props}
    >
      {children}
    </div>
  );
};
